import { GlobalAPIError, saveQuotePlanSelection } from '@shory-health-individual/customer-api';
import { useAppPlatformContextOptions } from '../../../contexts/app';
import { JourneyDetails } from '../../../server';
import { QuotePlanSchema } from '../quote-list';

type Props = {
	selectedQuote?: QuotePlanSchema;
	onSuccess: () => Promise<void>;
	journey: JourneyDetails;
};

export const useQuoteReview = ({ selectedQuote, onSuccess, journey }: Props) => {
	const { apiConnectionOptions, onGeneralErrorHandling } = useAppPlatformContextOptions();

	const onSaveSelectedQuote = async () => {
		try {
			const response = await saveQuotePlanSelection(apiConnectionOptions)({
				encryptedJourneyId: journey.encryptedJourneyId,
				quoteReference: journey.quoteReferenceNumber!,
				quotePlanReferenceNumber: selectedQuote?.quotePlanReferenceNumber ?? '',
			});

			if (response.isSuccess) await onSuccess();
		} catch (error) {
			await onGeneralErrorHandling(error as GlobalAPIError);
		}
	};

	return {
		onSaveSelectedQuote,
	};
};
